import CountUp from 'react-countup';
import { Col, Row } from "reactstrap";
import { P } from '../../../../AbstractElements';
import { SOCIAL_DATA } from '../../../../Data/Users';

const FollowSection = () => {
  return (
    <div className="follow">
      <Row>
        {SOCIAL_DATA.map((item, index) => (
          <Col xs="6 " className={item.class} key={index}>
           <CountUp end={item.count} className="follow-num counter"/>
            <P>{item.text}</P>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default FollowSection;
